import localizationModule from '../localization/localization';
export const storeNameSpace = {
  localizationModule,
};